import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

function initialTheme() {
    try {
        const v = localStorage.getItem("flatch_theme");
        if (v === "dark" || v === "light") return v;
    } catch (_) {}
    if (typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches) {
        return "dark";
    }
    return "light";
}

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(initialTheme);

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        try {
            localStorage.setItem("flatch_theme", theme);
        } catch (_) {}
    }, [theme]);

    const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeCtx.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeCtx) || { theme: "light", toggle: () => {}, setTheme: () => {} };
}
